import { Button } from 'ui';
import { useGetZipFile } from '../../../queries';

type P = {
  eventId: string;
};

const SaveZipButton = ({ eventId }: P) => {
  const { isPending: isLoading, mutate: handleSaveZip } = useGetZipFile();

  return (
    <Button
      loading={isLoading}
      onClick={(event) => {
        event.preventDefault();
        handleSaveZip({ id: eventId });
      }}
      type="link-primary"
    >
      Save all
    </Button>
  );
};

export default SaveZipButton;
